module.exports = __webpack_public_path__ + "img/1567810593.8c641a9f.jpg";